import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../utils/api";

const ACOES = [
  { acao: "confirmar", label: "Sim, cadastrar", cls: "bg-gray-900 text-white hover:bg-gray-800" },
  { acao: "adiar", label: "Me lembre em 5 min.", cls: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50" },
  { acao: "recusar", label: "Não", cls: "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50" },
];

/** Botões do aviso de possível hora parada (toast e sino). */
export function HoraParadaAcoes({ serviceId, onFeito }) {
  const [enviando, setEnviando] = useState(null);
  const decidir = async (acao, e) => {
    e.preventDefault();
    e.stopPropagation();
    setEnviando(acao);
    try {
      const { data } = await api.post(`/services/${serviceId}/hora-parada`, { acao });
      if (acao === "confirmar") {
        const valor = Number(data.valor_total || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
        toast.success(`1 hora parada cadastrada (${valor})`, {
          description: data.sem_valor
            ? "Sem valor na Tabela de Valores do cliente: confira o valor no Financeiro."
            : `Total no serviço: ${data.horas_total} ${data.horas_total === 1 ? "hora" : "horas"}.`,
        });
      } else {
        toast.success(acao === "adiar" ? "Vamos lembrar em 5 minutos" : "Ok, perguntaremos de novo na próxima hora");
      }
      onFeito?.();
    } catch (err) {
      const msg = formatApiError(err?.response?.data?.detail, "Não foi possível registrar agora.");
      if (err?.response?.status === 409) {
        toast.info("Este aviso já foi respondido", { description: msg });
        onFeito?.();
      } else {
        toast.error(msg);
      }
    } finally {
      setEnviando(null);
    }
  };
  return (
    <div className="flex flex-wrap gap-1.5 mt-2" data-testid={`hora-parada-acoes-${serviceId}`}>
      {ACOES.map((a) => (
        <button
          key={a.acao}
          type="button"
          disabled={!!enviando}
          onClick={(e) => decidir(a.acao, e)}
          className={`h-7 px-2.5 rounded-md whitespace-nowrap text-[11px] font-semibold transition-colors disabled:opacity-60 ${a.cls}`}
          data-testid={`hora-parada-${a.acao}-${serviceId}`}
        >
          {enviando === a.acao ? "Enviando..." : a.label}
        </button>
      ))}
    </div>
  );
}
